import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface IColConfig {
  name: string;
  class: string;
  show: boolean;
  disabled?: boolean;
}

export interface TableColFilterChange {
  cols: IColConfig[];
}

@Component({
  selector: 'stf-table-col-filter',
  templateUrl: './table-col-filter.component.html',
  styleUrls: ['./table-col-filter.component.scss'],
})
export class TableColFilterComponent {
  @Input() cols: IColConfig[] = [];
  @Output() colsChange = new EventEmitter<TableColFilterChange>();
  @Output() menuOpened = new EventEmitter<void>();
  @Input() color: string;
  @Input() icon: string = 'more_vert';

  onChange($event: Event, item: IColConfig): void {
    $event.stopPropagation();
    item.show = item.show ? false : true;
    this.colsChange.emit({ cols: this.cols });
  }

  trackByFn(index: number, item: IColConfig): string {
    return item.class;
  }

  onMenuOpened(): void {
    this.menuOpened.emit();
  }
}
